<img src="../../../assets/images/loading-spinner.gif" height="100" *ngIf="isLoading">



// WEBPACK FOOTER //
// /opt/app/src/app/core/loading-spinner/loading-spinner.component.html